import { render, staticRenderFns } from "./VerifiedFaults.vue?vue&type=template&id=3112f93a&scoped=true&"
import script from "./VerifiedFaults.vue?vue&type=script&lang=js&"
export * from "./VerifiedFaults.vue?vue&type=script&lang=js&"
import style0 from "./VerifiedFaults.vue?vue&type=style&index=0&id=3112f93a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3112f93a",
  null
  
)

export default component.exports